<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import * as globalEnum from "src/common/global-enum";
import { setInfo1, setInfo2 } from "./woven-config.js";
import printHead from "./print-head.vue";
import printFoot from "./print-foot.vue";
@Component({
  name: "woven",
  components: {
    printHead,
    printFoot
  }
})
export default class App extends Vue {
  @Prop({ type: Object, default: () => {} }) info;
  @Prop({ type: Number, default: () => -1 }) type;
  get setInfo() {
    const { table1Size } = this.$route.query;
    return setInfo1.call(this, this.info, Number(table1Size));
  }
  get setInfo2() {
    const { table2Size } = this.$route.query;
    console.log(table2Size)
    console.log(setInfo2.call(this, this.info, Number(table2Size)),'setInfo2.call(this, this.info, Number(table2Size))')
    return setInfo2.call(this, this.info, Number(table2Size));
  }
  get zoomStyle() {
    const { zoom } = this.$route.query;

    if(zoom  == 70) {
      return {
        fontSize: "10px",
        transform: "scale(0.6)",
        width: "165%",
      }
    } else if (zoom == 85) {
      return {
        fontSize: "10px",
        transform: "scale(0.8)",
        width: "125%",
      }
    } else {
      return {}
    }
  }
  mounted() {}
  render(h) {
    return (
      <div class="woven-page__print">
        <el-row>
          {true && (
            <el-row>
              <el-row class="woven-page__print-page">
                <printHead info={this.info}></printHead>
                <multiline-print
                  {...{
                    props: {
                      info: this.setInfo
                    }
                  }}
                ></multiline-print>
                <printFoot type={1} info={this.info}></printFoot>
              </el-row>
            </el-row>
          )}

          {true && (
            <el-row class="woven-page__print-page">
              <printHead info={this.info}></printHead>
              <multiline-print
                {...{
                  props: {
                    info: this.setInfo2
                  }
                }}
              ></multiline-print>
              <printFoot type={2} info={this.info}></printFoot>
            </el-row>
          )}

          {false && this.type === 4 && (
            <el-row class="woven-page__print-page">
              <printHead info={this.info}></printHead>
              <multiline-print
                {...{
                  props: {
                    info: this.setInfo2
                  }
                }}
              ></multiline-print>
            </el-row>
          )}
        </el-row>
      </div>
    );
  }
}
</script>

<style lang="scss" scoped>
@media print {
  .woven-page__print-page {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
    margin-bottom: 0mm;
  }
}
.woven-page__print-page {
  /* width: 190mm;
  height: 277mm; */
  page-break-inside: avoid !important;
  page-break-before: unset !important;
}
</style>